import type { ReactNode } from 'react'
import { Comment } from 'modules/comments/components/comment'
import type { CommentInterface } from 'modules/comments/components/comment/comment.types'
import type { OnErrorType } from 'modules/comments/types'
import { useCommentsContext } from './index'

export interface PinnedCommentsListProps {
  setActiveComment: (comment: CommentInterface | null) => void
  activeComment: CommentInterface | null
  onError?: OnErrorType
  highlightedCommentId: number | null
  onHighlightComplete: (commentId: number) => void
}

export const PinnedCommentsList = ({
  setActiveComment,
  activeComment,
  onError,
  highlightedCommentId,
  onHighlightComplete,
}: PinnedCommentsListProps): ReactNode => {
  const { pinnedComments } = useCommentsContext()
  return (
    <>
      {pinnedComments.map(pinnedComment => (
        <Comment
          key={pinnedComment.id}
          data={pinnedComment}
          level={0}
          setActiveComment={setActiveComment}
          activeComment={activeComment}
          onError={onError}
          highlightedCommentId={highlightedCommentId}
          onHighlightComplete={onHighlightComplete}
        />
      ))}
    </>
  )
}
